// import React, { useEffect, useState } from "react";
// import "./master-management.css";
// import "../assets/css/main.css";
// import { toast } from "react-toastify";
// import { NavLink } from "react-router-dom";
// import { confirmAlert } from "react-confirm-alert";
// import Select from "react-dropdown-select";
// import "react-confirm-alert/src/react-confirm-alert.css";
// import NoDataFoundImage from "../assets/images/no-data-found.svg";
// import {
//     getAllDepartments,
//     addDepartment,
//     updateDepartment,
//     getAllDesignations,
//     addDesignation,
//     updateDesignation,
//     addProcessor,
//     getProcessorTypes,
//     updateProcessor,
//     getValueForProcessor,
//     addBrandType,
//     updateBrandType,
//     addGeneration,
//     updateGeneration,
//     getAllLoginUsers,
//     getLoginUserById,
//     addUser,
//     updateUser,
//     getRoles
// } from "../../services/master-managementservice";
// import axiosInstance from "../../axios-interceptor";
// import { AppSettings } from "../../constant";
// const NAME_REGEX = /^[A-Za-z0-9]+(?: [A-Za-z0-9]+)*$/;
// const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

// function validateNameField(value, fieldLabel) {
//     if (!value) return `${fieldLabel} is required`;
//     if (/^\s/.test(value)) return `${fieldLabel} cannot start with a space`;

//     const trimmed = value.trim();
//     if (!trimmed) return `${fieldLabel} is required`;
//     if (trimmed.length < 2 || trimmed.length > 50) {
//         return `${fieldLabel} must be between 2 and 50 characters`;
//     }
//     if (!NAME_REGEX.test(trimmed)) {
//         return `Please enter valid ${fieldLabel}`;
//     }
//     return "";
// }

// function validateEmailField(value) {
//     const trimmed = value.trim();
//     if (!trimmed) return "This field is required";
//     if (!EMAIL_REGEX.test(trimmed)) {
//         return "Please enter valid email";
//     }
//     return "";
// }

// const EditIcon = () => (
//     <svg x="0px" y="0px" viewBox="0 0 700 700">
//         <g>
//             <path d="M631.3,133.8l-80-80C539.9,42.5,524.6,36,508.4,36c-16.2,0-31.5,6.5-42.8,17.8L117.1,402.2c-7.3,7.3-12.1,16.2-15.4,25.9l-49.3,169c-3.2,9.7,0,20.2,7.3,28.3c5.7,5.7,12.9,8.1,20.2,8.1c2.4,0,5.7,0,8.1-0.8l169-49.3c9.7-3.2,18.6-8.1,25.9-15.4l348.4-348.4c11.3-11.3,17.8-26.7,17.8-42.8C649.1,160.5,642.6,145.1,631.3,133.8z M147,475l63.1,63.1l-88.9,25.9L147,475z M590.9,179.9l-55,55l-85.7-85.7l55-55c0.8-0.8,2.4-0.8,3.2-0.8c0.8,0,1.6,0,3.2,0.8l80,80c0.8,0.8,0.8,2.4,0.8,3.2C592.5,178.3,591.7,179.1,590.9,179.9z" />
//         </g>
//     </svg>
// );

// const DeleteIcon = () => (
//     <svg x="0px" y="0px" viewBox="0 0 700 700">
//         <g>
//             <path d="M598.3,144.5H475.1v-26.9c0-19-17.4-33-39.2-33H297.6c-21.8,0-39.2,14.6-39.2,33v26.9H135.7c-12.3,0-21.8,9.5-21.8,21.8c0,12.3,9.5,21.8,21.8,21.8h26.9l26.9,336.6c0.6,39.8,32.5,71.7,72.2,71.7h210c39.8,0,71.7-31.9,72.2-71.7l27.4-336h26.9c12.3,0,21.8-9.5,21.8-21.8C620.1,154.6,610.6,144.5,598.3,144.5z M302,127.7H432v16.8l-129.9,0V127.7z M310.4,479.4h-0.6c-11.8,0-20.7-9.5-21.8-20.7l-7.8-176.4c-0.6-12.3,8.4-22.4,20.7-22.4h0.6c11.8,0,20.7,9.5,21.8,20.7l7.8,176.4C331.7,468.7,322.8,478.8,310.4,479.4z M446,458.1c-0.6,11.8-10.1,20.7-21.8,20.7h-0.6c-12.3-0.6-20.7-10.6-20.7-22.4l7.8-176.4c0.6-11.8,10.1-20.7,21.8-20.7h0.6c12.3,0.6,20.7,10.6,20.7,22.4L446,458.1z" />
//         </g>
//     </svg>
// );


// const PlusIcon = () => (
//     <svg viewBox="0 0 10 10" className="drill-plus-svg">
//         <path d="M5 0C4.636 0 4.342.295 4.342.658V4.342H.658C.295 4.342 0 4.637 0 5
//         s.295.658.658.658H4.342V9.342C4.342 9.705 4.636 10 5 10s.658-.295.658-.658
//         V5.658H9.342C9.705 5.658 10 5.363 10 5s-.295-.658-.658-.658H5.658V.658
//         C5.658.295 5.363 0 5 0z" />
//     </svg>
// );

// const ArrowIcon = ({ active }) => (
//     <svg className="drill-arrow-svg" viewBox="0 0 20 20">
//         <path
//             d="M7 4l6 6-6 6"
//             stroke={active ? "white" : "#9ca3af"}
//             strokeWidth="2"
//             fill="none"
//             strokeLinecap="round"
//             strokeLinejoin="round"
//         />
//     </svg>
// );

// const DrillRow = ({ label, active = false, onClick, onEdit }) => (
//     <div
//         className={`drill-row${active ? " drill-row--active" : ""}`}
//         onClick={onClick}
//     >
//         <div className={`drill-row__arrow${active ? " drill-row__arrow--active" : ""}`}>
//             <ArrowIcon active={active} />
//         </div>
//         <span className="drill-row__label">{label}</span>
//         <button
//             className="drill-row__edit-btn"
//             title="Edit"
//             onClick={onEdit}
//         >
//             <EditIcon />
//         </button>
//     </div>
// );

// const DrillColumn = ({ header, showAdd, onAdd, children }) => (
//     <div className="drill-col">
//         <div className="drill-col__header">
//             <span className="drill-col__header-title">{header}</span>
//             {showAdd && (
//                 <button
//                     type="button"
//                     className="drill-col__add-btn"
//                     title={`Add ${header}`}
//                     onClick={(e) => { e.stopPropagation(); onAdd(); }}
//                 >
//                     <PlusIcon />
//                 </button>
//             )}
//         </div>
//         <div className="drill-col__body">
//             {children}
//         </div>
//     </div>
// );

// const DrillEmpty = ({ message }) => (
//     <div className="drill-empty">
//         <span>{message}</span>
//     </div>
// );

// function MasterManagement() {
//     const [currentMaster, setCurrentMaster] = useState(
//         localStorage.getItem("currentMaster") || "Department"
//     );
//     const customId = "custom-id-yes";
//     const [currentPage, setCurrentPage] = useState(1);
//     const [data, setData] = useState([]);
//     const [loading, setLoading] = useState(false);
//     const [filteredData, setFilteredData] = useState([]);
//     const [searchFilter, setSearchFilter] = useState("");

//     const [expandedBrandId, setExpandedBrandId] = useState(null);
//     const [expandedBrandName, setExpandedBrandName] = useState("");
//     const [brandTypeDetails, setBrandTypeDetails] = useState([]);
//     const [generationDetails, setGenerationDetails] = useState([]);
//     const [expandLoading, setExpandLoading] = useState(false);
//     const [roles, setRoles] = useState([]);
//     const [rolesLoading, setRolesLoading] = useState(false);

//     const [isSidebarOpen, setIsSidebarOpen] = useState(false);
//     // sidebarMode: 'brand' | 'brandType' | 'generation' | 'department' | 'designation'
//     const [sidebarMode, setSidebarMode] = useState("");
//     const [sidebarAction, setSidebarAction] = useState("");
//     const [editItemId, setEditItemId] = useState(null);
//     const [sidebarValues, setSidebarValues] = useState({ name: "", brandName: "" });
//     const [nameErrorMsg, setNameErrorMsg] = useState("");
//     const [emailErrorMsg, setEmailErrorMsg] = useState("");
//     const [roleErrorMsg, setRoleErrorMsg] = useState("");

//     const fetchData = async (master) => {
//         setLoading(false);
//         setExpandedBrandId(null);
//         setBrandTypeDetails([]);
//         setGenerationDetails([]);
//         try {
//             let list = [];
//             if (master === "Department") list = await getAllDepartments();
//             else if (master === "Designation") list = await getAllDesignations();
//             else if (master === "Processor") list = await getProcessorTypes();
//             else if (master === "User") list = await getAllLoginUsers();
//             setData(list);
//             setFilteredData(list);
//         } catch (err) {
//             console.log(err.message);
//         } finally {
//             setLoading(true);
//         }
//     };

//     useEffect(() => {
//         fetchData(currentMaster);
//     }, []);

//     useEffect(() => {
//         if (isSidebarOpen) {
//             document.body.style.overflow = "hidden";
//         } else {
//             document.body.style.overflow = "";
//         }
//         return () => {
//             document.body.style.overflow = "";
//         };
//     }, [isSidebarOpen]);

//     useEffect(() => {
//         const fetchRoles = async () => {
//             setRolesLoading(true);
//             try {
//                 const list = await getRoles();
//                 setRoles(list);
//             } catch {
//                 // silent
//             } finally {
//                 setRolesLoading(false);
//             }
//         };
//         fetchRoles();
//     }, []);

//     const handleBrandClick = async (item) => {

//         if (expandedBrandId === item.brandId) {
//             setExpandedBrandId(null);
//             setExpandedBrandName("");
//             setBrandTypeDetails([]);
//             setGenerationDetails([]);
//             return;
//         }
//         setExpandedBrandId(item.brandId);
//         setExpandedBrandName(item.brandName);
//         setExpandLoading(true);
//         try {
//             const res = await getValueForProcessor(item.brandName);
//             setBrandTypeDetails(res.brandTypeDetails || []);
//             setGenerationDetails(res.generationDetails || []);
//         } catch {
//             toast.error("Failed to load processor details", { toastId: customId });
//         } finally {
//             setExpandLoading(false);
//         }
//     };

//     const handleMasterClick = (master) => {
//         setData([]);
//         setFilteredData([]);
//         setSearchFilter("");
//         setCurrentPage(1);
//         setCurrentMaster(master);
//         localStorage.setItem("currentMaster", master);
//         fetchData(master);
//     };

//     const handleSearch = (value) => {
//         const temp = data.filter((obj) => {
//             for (const key in obj) {
//                 if (
//                     typeof obj[key] === "string" &&
//                     obj[key].toLowerCase().includes(value.toLowerCase())
//                 )
//                     return true;
//             }
//             return false;
//         });
//         setFilteredData(temp);
//         setCurrentPage(1);
//     };


//     const openSidebar = (mode, action, item = null) => {
//         setSidebarMode(mode);
//         setSidebarAction(action);
//         // setSidebarError(false);
//         setNameErrorMsg("");
//         setEmailErrorMsg("");
//         setRoleErrorMsg("");
//         setIsSidebarOpen(true);

//         if (action === "edit" && item) {
//             if (mode === "brand") {
//                 setEditItemId(item.brandId);
//                 setSidebarValues({ name: item.brandName, brandName: "" });
//             } else if (mode === "brandType") {
//                 setEditItemId(item.id ?? item.brandTypeId);
//                 setSidebarValues({ name: item.brandTypeName, brandName: expandedBrandName });
//             } else if (mode === "generation") {
//                 setEditItemId(item.id ?? item.generationId);
//                 setSidebarValues({ name: item.generation, brandName: expandedBrandName });
//             } else if (mode === "department") {
//                 setEditItemId(item.id);
//                 setSidebarValues({ name: item.departmentName, brandName: "" });
//             } else if (mode === "designation") {
//                 setEditItemId(item.id);
//                 setSidebarValues({ name: item.designationName, brandName: "" });
//             } else if (mode === "user") {
//                 setEditItemId(item.id);
//                 getLoginUserById(item.id)
//                     .then((u) => {
//                         setSidebarValues({
//                             name: u?.username ?? item.username,
//                             emailid: u?.emailid ?? item.emailid,
//                             roleid: u?.roleid ?? item.roleid ?? "",
//                             brandName: "",
//                         });
//                     })
//                     .catch(() => {
//                         setSidebarValues({
//                             name: item.username,
//                             emailid: item.emailid,
//                             roleid: item.roleid ?? "",
//                             brandName: "",
//                         });
//                     });
//             }
//         }
//         else {
//             setEditItemId(null);
//             setSidebarValues({ name: "", emailid: "", roleid: "", brandName: expandedBrandName });
//         }
//     };

//     const closeSidebar = () => {
//         setIsSidebarOpen(false);
//         setSidebarMode("");
//         setSidebarAction("");
//         setEditItemId(null);
//         setSidebarValues({ name: "", emailid: "", roleid: "", brandName: "" });
//         // setSidebarError(false);
//         setNameErrorMsg("");
//         setEmailErrorMsg("");
//         setRoleErrorMsg("");
//     };

//     const getSidebarTitle = () => {
//         const verb = sidebarAction === "add" ? "Add" : "Update";
//         if (sidebarMode === "brand") return `${verb} Processor Brand`;
//         if (sidebarMode === "brandType") return `${verb} Processor Type`;
//         if (sidebarMode === "generation") return `${verb} Generation`;
//         if (sidebarMode === "department") return `${verb} Department`;
//         if (sidebarMode === "designation") return `${verb} Designation`;
//         if (sidebarMode === "user") return `${verb} User`;
//         return verb;
//     };

//     const getFieldLabel = () => {
//         if (sidebarMode === "brand") return "Processor Brand Name";
//         if (sidebarMode === "brandType") return "Processor Type Name";
//         if (sidebarMode === "generation") return "Generation";
//         if (sidebarMode === "department") return "Department Name";
//         if (sidebarMode === "designation") return "Designation Name";
//         if (sidebarMode === "user") return "User Name";
//         return "Name";
//     };

//       const getFieldPlaceholder = () => {
//         if (sidebarMode === "brand") return "Enter Processor Brand Name";
//         if (sidebarMode === "brandType") return "Enter Processor Type Name";
//         if (sidebarMode === "generation") return "Enter Generation";
//         if (sidebarMode === "department") return "Enter Department Name";
//         if (sidebarMode === "designation") return "Enter Designation Name";
//         if (sidebarMode === "user") return "Enter User Name";
//         return "Name";
//     };

//     const getFieldMessageLabel = () => {
//         if (sidebarMode === "brand") return "Processor brand name";
//         if (sidebarMode === "brandType") return "Processor type name";
//         if (sidebarMode === "generation") return "Generation";
//         if (sidebarMode === "department") return "Department name";
//         if (sidebarMode === "designation") return "Designation name";
//         if (sidebarMode === "user") return "User name";
//         return "Name";
//     };

//     // const handleSidebarSubmit = async () => {
//     //     const trimmed = sidebarValues.name.trim();
//     //     const emailTrimmed = sidebarValues.emailid?.trim() || "";
//     //     const roleidVal = sidebarValues.roleid;

//     //     if (!trimmed || (sidebarMode === "user" && (!emailTrimmed || !roleidVal))) {
//     //         setSidebarError(true);
//     //         toast.error("Please fill all the required fields", { toastId: customId });
//     //         return;
//     //     }
//     //     setSidebarError(false);

//     const handleSidebarSubmit = async () => {
//         const trimmed = sidebarValues.name.trim();
//         const emailTrimmed = sidebarValues.emailid?.trim() || "";
//         const roleidVal = sidebarValues.roleid;

//         const nameMsg = validateNameField(sidebarValues.name, getFieldMessageLabel());
//         const emailMsg = sidebarMode === "user" ? validateEmailField(emailTrimmed) : "";
//         const roleMsg = sidebarMode === "user" && !roleidVal ? "Please select a role" : "";

//         setNameErrorMsg(nameMsg);
//         setEmailErrorMsg(emailMsg);
//         setRoleErrorMsg(roleMsg);

//         if (nameMsg || emailMsg || roleMsg) {
//             toast.error(nameMsg || emailMsg || roleMsg, { toastId: customId });
//             return;
//         }


//         try {
//             let res;

//             if (sidebarAction === "add") {
//                 if (sidebarMode === "brand") {
//                     res = await addProcessor(trimmed);
//                 } else if (sidebarMode === "brandType") {
//                     res = await addBrandType(expandedBrandId, trimmed);
//                 } else if (sidebarMode === "generation") {
//                     res = await addGeneration(expandedBrandId, trimmed);
//                 } else if (sidebarMode === "department") {
//                     res = await addDepartment(trimmed);
//                 } else if (sidebarMode === "designation") {
//                     res = await addDesignation(trimmed);
//                 } else if (sidebarMode === "user") {
//                     res = await addUser({
//                         username: trimmed,
//                         emailid: emailTrimmed,
//                         roleid: Number(roleidVal),
//                     });
//                 }
//             } else {
//                 if (sidebarMode === "brand") {
//                     res = await updateProcessor(editItemId, trimmed);
//                 } else if (sidebarMode === "brandType") {
//                     res = await updateBrandType(editItemId, trimmed);
//                 } else if (sidebarMode === "generation") {
//                     res = await updateGeneration(editItemId, trimmed);
//                 } else if (sidebarMode === "department") {
//                     res = await updateDepartment(editItemId, trimmed);
//                 } else if (sidebarMode === "designation") {
//                     res = await updateDesignation(editItemId, trimmed);
//                 } else if (sidebarMode === "user") {
//                     res = await updateUser({
//                         id: editItemId,
//                         username: trimmed,
//                         emailid: emailTrimmed,
//                         roleid: Number(roleidVal),
//                     });
//                 }
//             }

//             if (res?.statuscode === 200 || res?.response === true) {
//                 toast.success(res?.message || `${sidebarAction === "add" ? "Added" : "Updated"} successfully`, {
//                     toastId: customId,
//                 });
//                 closeSidebar();
//                 if (sidebarMode === "brand") {
//                     fetchData("Processor");
//                 } else if (sidebarMode === "brandType" || sidebarMode === "generation") {
//                     const res2 = await getValueForProcessor(expandedBrandName);
//                     setBrandTypeDetails(res2.brandTypeDetails || []);
//                     setGenerationDetails(res2.generationDetails || []);
//                 } else {
//                     fetchData(currentMaster);
//                 }
//             } else {
//                 toast.error(res?.message || "Something went wrong", { toastId: customId });
//             }
//         } catch {
//             toast.error("Something went wrong", { toastId: customId });
//         }
//     };

//     const handleDelete = (item) => {
//         confirmAlert({
//             title: `Delete ${currentMaster}`,
//             message: `Are you sure you want to delete this ${currentMaster}?`,
//             buttons: [
//                 {
//                     label: "Yes",
//                     onClick: async () => {
//                         try {
//                             let url = "";
//                             if (currentMaster === "Department")
//                                 url = AppSettings.URLs.asset + `Master/DeleteDepartment?id=${item.id}`;
//                             else if (currentMaster === "Designation")
//                                 url = AppSettings.URLs.asset + `Master/DeleteDesignation?id=${item.id}`;
//                             else return;
//                             await axiosInstance.delete(url);
//                             toast.success("Deleted successfully", { toastId: customId });
//                             fetchData(currentMaster);
//                         } catch {
//                             toast.error("Something went wrong", { toastId: customId });
//                         }
//                     },
//                 },
//                 { label: "No" },
//             ],
//         });
//     };

//     const itemsPerPage = 10;
//     const totalPages = Math.ceil((filteredData?.length || 0) / itemsPerPage);
//     const startIndex = (currentPage - 1) * itemsPerPage;
//     const endIndex = currentPage * itemsPerPage;
//     const displayedData = filteredData.slice(startIndex, endIndex);

//     const goToPreviousPage = () => { if (currentPage > 1) setCurrentPage((p) => p - 1); };
//     const goToNextPage = () => { if (endIndex < filteredData.length) setCurrentPage((p) => p + 1); };

//     const renderPageNumbers = () => {
//         const maxToShow = 3;
//         const pageNumbers = [];
//         let startPage, endPage;
//         if (totalPages <= maxToShow) { startPage = 1; endPage = totalPages; }
//         else {
//             const mid = Math.ceil(maxToShow / 2);
//             if (currentPage <= mid) { startPage = 1; endPage = maxToShow; }
//             else if (currentPage + mid - 1 >= totalPages) { startPage = totalPages - maxToShow + 1; endPage = totalPages; }
//             else { startPage = currentPage - mid + 1; endPage = currentPage + mid - 1; }
//         }
//         if (startPage > 1) { pageNumbers.push(1); if (startPage > 2) pageNumbers.push("..."); }
//         for (let i = startPage; i <= endPage; i++) pageNumbers.push(i);
//         if (endPage < totalPages) { if (endPage < totalPages - 1) pageNumbers.push("..."); pageNumbers.push(totalPages); }

//         return pageNumbers.map((n, i) =>
//             typeof n === "number" ? (
//                 <li key={i} className={`inline-block cursor-pointer hover:backdrop-brightness-90 ${currentPage === n ? "current" : ""}`} onClick={() => setCurrentPage(n)}>
//                     <span>{n}</span>
//                 </li>
//             ) : (
//                 <li key={i} className="inline-block mx-1">{n}</li>
//             )
//         );
//     };

//     const getNonProcessorMode = () => {
//         if (currentMaster === "Department") return "department";
//         if (currentMaster === "Designation") return "designation";
//         if (currentMaster === "User") return "user";
//         return "";
//     };

//     const getColumnLabel = () => {
//         if (currentMaster === "Department") return "Department Name";
//         if (currentMaster === "Designation") return "Designation Name";
//         if (currentMaster === "User") return "User Name";
//         return "";
//     };

//     const getColumnKey = () => {
//         if (currentMaster === "Department") return "departmentName";
//         if (currentMaster === "Designation") return "designationName";
//         if (currentMaster === "User") return "username";
//         return "";
//     };

//     return (
//         <>
//             {/* Page header */}
//             <div className="page-titles bg-white px-6">
//                 <div className="flex items-center">
//                     <div className="mr-4 kr-page-back-btn">
//                         <NavLink to="/master" className="no-underline">
//                             <button type="button" className="btn-primary rounded flex items-center justify-center w-8">
//                                 <svg width={18} className="svg-white" x="0px" y="0px" viewBox="0 0 700 700">
//                                     <g>
//                                         <path d="M82.9,331.2l148.3,148.3c7.6,7.6,18.6,10.6,29,7.8c10.4-2.8,18.5-10.9,21.2-21.2c2.8-10.4-0.2-21.4-7.8-29l-97.6-96.9h304.7c15.8,0,31,6.3,42.1,17.5c11.2,11.2,17.5,26.3,17.5,42.1v79c0,10.6,5.7,20.5,14.9,25.8c9.2,5.3,20.6,5.3,29.8,0c9.2-5.3,14.9-15.2,14.9-25.8v-79c0-31.6-12.6-61.9-34.9-84.3c-22.4-22.4-52.7-34.9-84.3-34.9H176.1l97.6-97.6c7.6-7.6,10.6-18.6,7.8-29c-2.8-10.4-10.9-18.5-21.2-21.2c-10.4-2.8-21.4,0.2-29,7.8L82.9,288.7c-5.7,5.6-8.9,13.3-8.9,21.2S77.2,325.6,82.9,331.2z" />
//                                     </g>
//                                 </svg>
//                             </button>
//                         </NavLink>
//                     </div>
//                     <div>
//                         <h2 className="font-bold color-dark text-[14px] mb-0">Masters</h2>
//                         <span className="text-gray-400 text-[12px]">View all masters listing</span>
//                     </div>
//                 </div>
//             </div>

//             <div className="pageBody-inner px-0 pt-0">
//                 <div className="kr-block">
//                     <div className="tabs">

//                         <div className="tab-button-outer">
//                             <div id="tab-button">
//                                 {["Department", "Designation", "Processor", "User"].map((tab) => (
//                                     <li key={tab} className={currentMaster === tab ? "is-active" : ""}>
//                                         <div className="kr-asset-tab" onClick={() => handleMasterClick(tab)}>
//                                             <div className={`kr-emp-tab ${currentMaster === tab ? "kr-emp-tab-active border-danger border-top-0 border-end-0 border-start-0 border-2 text-dark" : ""}`}>
//                                                 {tab}
//                                             </div>
//                                         </div>
//                                     </li>
//                                 ))}
//                             </div>
//                         </div>

//                         <div className="pageBody-inner p-6">
//                             <div className="kr-block">
//                                 <div className="card !border-none">
//                                     <div className="card-inner p-0">

//                                         {currentMaster !== "Processor" && (
//                                             <div className="kr-table-header border-bottom px-6 py-3">
//                                                 <div className="w-100 flex items-center justify-between">
//                                                     <div className="flex place-content-center user-search-filter-parent h-[32px]">
//                                                         <input
//                                                             type="text"
//                                                             value={searchFilter}
//                                                             placeholder="Search..."
//                                                             className="user-search-filter-input"
//                                                             onChange={(e) => {
//                                                                 setSearchFilter(e.target.value);
//                                                                 handleSearch(e.target.value);
//                                                             }}
//                                                         />
//                                                     </div>
//                                                     <button
//                                                         type="button"
//                                                         className="btn btn-primary flex justify-center items-center min-w-80 cursor-pointer"
//                                                         onClick={() => openSidebar(getNonProcessorMode(), "add")}
//                                                     >
//                                                         Create
//                                                     </button>
//                                                 </div>
//                                             </div>
//                                         )}

//                                         <div className="kr-block px-3 pt-2 pb-3">
//                                             <div className="overflow-x-auto">
//                                                 {loading ? (
//                                                     <>
//                                                         {currentMaster === "Processor" && (
//                                                             <div className="drill-wrap">

//                                                                 <DrillColumn
//                                                                     header="Processor Brand"
//                                                                     showAdd={true}
//                                                                     onAdd={() => openSidebar("brand", "add")}
//                                                                 >
//                                                                     {displayedData.length === 0 ? (
//                                                                         <DrillEmpty message="No brands found" />
//                                                                     ) : (
//                                                                         displayedData.map((brand) => (
//                                                                             <DrillRow
//                                                                                 key={brand.brandId}
//                                                                                 label={brand.brandName}
//                                                                                 active={expandedBrandId === brand.brandId}
//                                                                                 onClick={() => handleBrandClick(brand)}
//                                                                                 onEdit={(e) => {
//                                                                                     e.stopPropagation();
//                                                                                     openSidebar("brand", "edit", brand);
//                                                                                 }}
//                                                                             />
//                                                                         ))
//                                                                     )}
//                                                                 </DrillColumn>

//                                                                 <DrillColumn
//                                                                     header="Processor Type"
//                                                                     showAdd={!!expandedBrandId}
//                                                                     onAdd={() => openSidebar("brandType", "add")}
//                                                                 >
//                                                                     {!expandedBrandId ? (
//                                                                         <DrillEmpty message="Select a brand" />
//                                                                     ) : expandLoading ? (
//                                                                         <div className="drill-loading">
//                                                                             <div className="kr-pageLoader"><span className="loader"></span></div>
//                                                                         </div>
//                                                                     ) : brandTypeDetails.length === 0 ? (
//                                                                         <DrillEmpty message="No types added yet" />
//                                                                     ) : (
//                                                                         brandTypeDetails.map((t, i) => (
//                                                                             <DrillRow
//                                                                                 key={t.brandTypeId ?? i}
//                                                                                 label={t.brandTypeName}
//                                                                                 onClick={() => { }}
//                                                                                 onEdit={(e) => {
//                                                                                     e.stopPropagation();
//                                                                                     openSidebar("brandType", "edit", t);
//                                                                                 }}
//                                                                             />
//                                                                         ))
//                                                                     )}
//                                                                 </DrillColumn>


//                                                                 <DrillColumn
//                                                                     header="Process Generation"
//                                                                     showAdd={!!expandedBrandId}
//                                                                     onAdd={() => openSidebar("generation", "add")}
//                                                                 >
//                                                                     {!expandedBrandId ? (
//                                                                         <DrillEmpty message="Select a brand" />
//                                                                     ) : expandLoading ? (
//                                                                         <div className="drill-loading">
//                                                                             <div className="kr-pageLoader"><span className="loader"></span></div>
//                                                                         </div>
//                                                                     ) : generationDetails.length === 0 ? (
//                                                                         <DrillEmpty message="No generations added yet" />
//                                                                     ) : (
//                                                                         generationDetails.map((g, i) => (
//                                                                             <DrillRow
//                                                                                 key={g.generationId ?? i}
//                                                                                 label={g.generation}
//                                                                                 onClick={() => { }}
//                                                                                 onEdit={(e) => {
//                                                                                     e.stopPropagation();
//                                                                                     openSidebar("generation", "edit", g);
//                                                                                 }}
//                                                                             />
//                                                                         ))
//                                                                     )}
//                                                                 </DrillColumn>

//                                                             </div>
//                                                         )}

//                                                         {currentMaster !== "Processor" && (
//                                                             <table className="table kr-table-striped">
//                                                                 {/* <thead>
//                                                                     <tr>
//                                                                         <th className="text-center">#</th>
//                                                                         <th>{getColumnLabel()}</th>
//                                                                         <th className="text-center">Action</th>
//                                                                     </tr>
//                                                                 </thead> */}
//                                                                 <thead>
//                                                                     <tr>
//                                                                         <th className="text-center">#</th>
//                                                                         <th>{getColumnLabel()}</th>
//                                                                         {currentMaster === "User" && <th>Email ID</th>}
//                                                                         {currentMaster === "User" && <th>Role</th>}
//                                                                         <th className="text-center">Action</th>
//                                                                     </tr>
//                                                                 </thead>
//                                                                 <tbody>
//                                                                     {displayedData.map((item, index) => (
//                                                                         <tr key={index}>
//                                                                             <td className="text-center">{startIndex + index + 1}</td>
//                                                                             {/* <td className="uppercase">{item[getColumnKey()]}</td> */}
//                                                                             <td>{item[getColumnKey()]}</td>
//                                                                             {currentMaster === "User" && <td>{item.emailid}</td>}
//                                                                             {currentMaster === "User" && <td>{item.rolename}</td>}
//                                                                             <td className="kr-tbl-action">
//                                                                                 <div className="flex justify-center shrink-0">
//                                                                                     <ul className="flex">
//                                                                                         <li>
//                                                                                             <div
//                                                                                                 className="kr-tbl-edit cursor-pointer action-item"
//                                                                                                 onClick={() => openSidebar(getNonProcessorMode(), "edit", item)}
//                                                                                             >
//                                                                                                 <span className="svg-icon"><EditIcon /></span>
//                                                                                             </div>
//                                                                                         </li>
//                                                                                         {/* <li>
//                                                                                             <div
//                                                                                                 className="kr-tbl-delete cursor-pointer action-item"
//                                                                                                 onClick={() => handleDelete(item)}
//                                                                                             >
//                                                                                                 <span className="svg-icon"><DeleteIcon /></span>
//                                                                                             </div>
//                                                                                         </li> */}
//                                                                                     </ul>
//                                                                                 </div>
//                                                                             </td>
//                                                                         </tr>
//                                                                     ))}
//                                                                 </tbody>
//                                                             </table>
//                                                         )}
//                                                     </>
//                                                 ) : (
//                                                     <div className="w-100 flex justify-center items-center py-6 bg-light">
//                                                         <div className="kr-pageLoader"><span className="loader"></span></div>
//                                                     </div>
//                                                 )}
//                                             </div>
//                                         </div>

//                                         {/* Pagination */}
//                                         <div className="kr-block pt-3 pb-3 font-size-12px color-gray border-top px-3">
//                                             <nav className="w-full m-0">
//                                                 <ul className="list-none ml-0 mb-0 pagination">
//                                                     <li className={`inline-block pagination-prev cursor-pointer ${currentPage === 1 ? "disabled" : ""}`} onClick={goToPreviousPage}>
//                                                         <span>Previous</span>
//                                                     </li>
//                                                     {renderPageNumbers()}
//                                                     <li className={`inline-block pagination-next cursor-pointer ${endIndex >= filteredData?.length ? "disabled" : ""}`} onClick={goToNextPage}>
//                                                         <span>Next</span>
//                                                     </li>
//                                                 </ul>
//                                             </nav>
//                                         </div>

//                                     </div>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>

//             {/*Sidebar */}
//             <div className={`kr-popup-overlay ${isSidebarOpen ? "kr-side-popup-overlay" : ""}`}></div>
//             <div className={`kr-side-popup ${isSidebarOpen ? "kr-side-popup-on md:!w-[500px] !w-[90vw]" : ""}`}>
//                 <div className="kr-block w-100">
//                     <div className="flex items-center py-[16px] px-6 bg-gray-50">
//                         <div className="pl-2">
//                             <h2 className="font-bold color-dark text-[14px] mb-0">{getSidebarTitle()}</h2>
//                             <span className="text-gray-400 text-[12px]">
//                                 {sidebarAction === "add" ? "Create" : "Update"} below
//                             </span>
//                         </div>
//                     </div>
//                     <div className="kr-block p-4">
//                         <div className="grid gap-x-4 grid-cols-1">

//                             {(sidebarMode === "brandType" || sidebarMode === "generation") && (
//                                 <div className="col-span-1 mb-3">
//                                     <div className="kr-selectform">
//                                         <label className="kr-form-label">Processor Brand</label>
//                                         <input
//                                             type="text"
//                                             value={expandedBrandName}
//                                             readOnly
//                                             className="form-control kr-form-textbox bg-gray-100 text-gray-500"
//                                         />
//                                     </div>
//                                 </div>
//                             )}

//                             <div className="col-span-1">
//                                 <div className="kr-selectform required">
//                                     <label className="kr-form-label">{getFieldLabel()}</label>
//                                     <input
//                                         type="text"
//                                         placeholder={getFieldPlaceholder()}
//                                         value={sidebarValues.name}
//                                         maxLength={50}
//                                         className={`form-control kr-form-textbox placeholder-[#212529] ${nameErrorMsg ? "dataError" : ""}`}
//                                         onChange={(e) => {
//                                             let val = e.target.value;

//                                             if (val.length > 0) {
//                                                 val = val.charAt(0).toUpperCase() + val.slice(1);
//                                             }

//                                             val = val.replace(/ {2,}/g, " ");

//                                             setSidebarValues((v) => ({ ...v, name: val }));
//                                             if (nameErrorMsg) {
//                                                 const msg = validateNameField(val, getFieldMessageLabel());
//                                                 setNameErrorMsg(msg);
//                                             }
//                                         }}
//                                         onBlur={(e) => setNameErrorMsg(validateNameField(e.target.value, getFieldMessageLabel()))}
//                                     />
//                                     {nameErrorMsg && (
//                                         <span className="text-red-500 text-[11px] mt-1 block">{nameErrorMsg}</span>
//                                     )}
//                                 </div>
//                             </div>

//                             {sidebarMode === "user" && (
//                                 <>
//                                     <div className="kr-selectform required">
//                                         <label className="kr-form-label">Email ID</label>
//                                         <input
//                                             type="email"
//                                             placeholder="Enter Email ID"
//                                             value={sidebarValues.emailid || ""}
//                                             className={`form-control kr-form-textbox placeholder-[#212529] ${emailErrorMsg ? "dataError" : ""}`}
//                                             onChange={(e) => {
//                                                 setSidebarValues((v) => ({ ...v, emailid: e.target.value }));
//                                                 if (emailErrorMsg) {
//                                                     setEmailErrorMsg(validateEmailField(e.target.value));
//                                                 }
//                                             }}
//                                             onBlur={(e) => setEmailErrorMsg(validateEmailField(e.target.value))}
//                                         />
//                                         {emailErrorMsg && (
//                                             <span className="text-red-500 text-[11px] mt-1 block">{emailErrorMsg}</span>
//                                         )}
//                                     </div>

//                                     <div className="kr-selectform required">
//                                         <label className="kr-form-label">Role</label>
//                                         <Select
//                                             searchable={false}
//                                             backspaceDelete={false}
//                                             placeholder="Select Role"
//                                             values={
//                                                 sidebarValues.roleid
//                                                     ? [{ value: sidebarValues.roleid, label: roles.find(r => String(r.id) === String(sidebarValues.roleid))?.roleName || "" }]
//                                                     : []
//                                             }
//                                             className={`form-control kr-form-textbox placeholder-[#212529] ${roleErrorMsg ? "dataError" : ""}`}
//                                             options={roles.map((r) => ({
//                                                 value: r.id,
//                                                 label: r.roleName,
//                                             }))}
//                                             onChange={(selectedOption) => {
//                                                 setSidebarValues((v) => ({ ...v, roleid: selectedOption[0]?.value ?? "" }));
//                                                 setRoleErrorMsg("");
//                                             }}
//                                         />
//                                         {roleErrorMsg && (
//                                             <span className="text-red-500 text-[11px] mt-1 block">{roleErrorMsg}</span>
//                                         )}
//                                     </div>

//                                 </>
//                             )}

//                             <div className="col-span-1 mt-4">
//                                 <div className="kr-selectform flex justify-end">
//                                     <button
//                                         type="button"
//                                         className="flex items-center justify-center py-[6px] px-[12px] btn-light border border-solid border-gray-200 rounded min-w-80"
//                                         onClick={closeSidebar}
//                                     >
//                                         Cancel
//                                     </button>
//                                     <button
//                                         type="button"
//                                         className="btn btn-primary flex items-center justify-center ml-2 min-w-80"
//                                         onClick={handleSidebarSubmit}
//                                     >
//                                         {sidebarAction === "add" ? "Add" : "Update"}
//                                     </button>
//                                 </div>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//             </div>
//         </>
//     );
// }

// export default MasterManagement;

import React, { useEffect, useState } from "react";
import "./master-management.css";
import "../assets/css/main.css";
import { toast } from "react-toastify";
import { NavLink } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import Select from "react-dropdown-select";
import "react-confirm-alert/src/react-confirm-alert.css";
import NoDataFoundImage from "../assets/images/no-data-found.svg";
import {
    getAllDepartments,
    addDepartment,
    updateDepartment,
    getAllDesignations,
    addDesignation,
    updateDesignation,
    addProcessor,
    getProcessorTypes,
    updateProcessor,
    getValueForProcessor,
    addBrandType,
    updateBrandType,
    addGeneration,
    updateGeneration,
    getAllLoginUsers,
    getLoginUserById,
    addUser,
    updateUser,
    getRoles
} from "../../services/master-managementservice";
import axiosInstance from "../../axios-interceptor";
import { AppSettings } from "../../constant";
const NAME_REGEX = /^[A-Za-z0-9]+(?: [A-Za-z0-9]+)*$/;
const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

function validateNameField(value, fieldLabel) {
    if (!value) return `${fieldLabel} is required`;
    if (/^\s/.test(value)) return `${fieldLabel} cannot start with a space`;

    const trimmed = value.trim();
    if (!trimmed) return `${fieldLabel} is required`;
    if (trimmed.length < 2 || trimmed.length > 50) {
        return `${fieldLabel} must be between 2 and 50 characters`;
    }
    if (!NAME_REGEX.test(trimmed)) {
        return `Please enter valid ${fieldLabel}`;
    }
    return "";
}

function validateEmailField(value) {
    const trimmed = value.trim();
    if (!trimmed) return "This field is required";
    if (!EMAIL_REGEX.test(trimmed)) {
        return "Please enter valid email";
    }
    return "";
}

const EditIcon = () => (
    <svg x="0px" y="0px" viewBox="0 0 700 700">
        <g>
            <path d="M631.3,133.8l-80-80C539.9,42.5,524.6,36,508.4,36c-16.2,0-31.5,6.5-42.8,17.8L117.1,402.2c-7.3,7.3-12.1,16.2-15.4,25.9l-49.3,169c-3.2,9.7,0,20.2,7.3,28.3c5.7,5.7,12.9,8.1,20.2,8.1c2.4,0,5.7,0,8.1-0.8l169-49.3c9.7-3.2,18.6-8.1,25.9-15.4l348.4-348.4c11.3-11.3,17.8-26.7,17.8-42.8C649.1,160.5,642.6,145.1,631.3,133.8z M147,475l63.1,63.1l-88.9,25.9L147,475z M590.9,179.9l-55,55l-85.7-85.7l55-55c0.8-0.8,2.4-0.8,3.2-0.8c0.8,0,1.6,0,3.2,0.8l80,80c0.8,0.8,0.8,2.4,0.8,3.2C592.5,178.3,591.7,179.1,590.9,179.9z" />
        </g>
    </svg>
);

const DeleteIcon = () => (
    <svg x="0px" y="0px" viewBox="0 0 700 700">
        <g>
            <path d="M598.3,144.5H475.1v-26.9c0-19-17.4-33-39.2-33H297.6c-21.8,0-39.2,14.6-39.2,33v26.9H135.7c-12.3,0-21.8,9.5-21.8,21.8c0,12.3,9.5,21.8,21.8,21.8h26.9l26.9,336.6c0.6,39.8,32.5,71.7,72.2,71.7h210c39.8,0,71.7-31.9,72.2-71.7l27.4-336h26.9c12.3,0,21.8-9.5,21.8-21.8C620.1,154.6,610.6,144.5,598.3,144.5z M302,127.7H432v16.8l-129.9,0V127.7z M310.4,479.4h-0.6c-11.8,0-20.7-9.5-21.8-20.7l-7.8-176.4c-0.6-12.3,8.4-22.4,20.7-22.4h0.6c11.8,0,20.7,9.5,21.8,20.7l7.8,176.4C331.7,468.7,322.8,478.8,310.4,479.4z M446,458.1c-0.6,11.8-10.1,20.7-21.8,20.7h-0.6c-12.3-0.6-20.7-10.6-20.7-22.4l7.8-176.4c0.6-11.8,10.1-20.7,21.8-20.7h0.6c12.3,0.6,20.7,10.6,20.7,22.4L446,458.1z" />
        </g>
    </svg>
);


const PlusIcon = () => (
    <svg viewBox="0 0 10 10" className="drill-plus-svg">
        <path d="M5 0C4.636 0 4.342.295 4.342.658V4.342H.658C.295 4.342 0 4.637 0 5
        s.295.658.658.658H4.342V9.342C4.342 9.705 4.636 10 5 10s.658-.295.658-.658
        V5.658H9.342C9.705 5.658 10 5.363 10 5s-.295-.658-.658-.658H5.658V.658
        C5.658.295 5.363 0 5 0z" />
    </svg>
);

const ArrowIcon = ({ active }) => (
    <svg className="drill-arrow-svg" viewBox="0 0 20 20">
        <path
            d="M7 4l6 6-6 6"
            stroke={active ? "white" : "#9ca3af"}
            strokeWidth="2"
            fill="none"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

const DrillRow = ({ label, active = false, onClick, onEdit }) => (
    <div
        className={`drill-row${active ? " drill-row--active" : ""}`}
        onClick={onClick}
    >
        <div className={`drill-row__arrow${active ? " drill-row__arrow--active" : ""}`}>
            <ArrowIcon active={active} />
        </div>
        <span className="drill-row__label">{label}</span>
        <button
            className="drill-row__edit-btn"
            title="Edit"
            onClick={onEdit}
        >
            <EditIcon />
        </button>
    </div>
);

const DrillColumn = ({ header, showAdd, onAdd, children }) => (
    <div className="drill-col">
        <div className="drill-col__header">
            <span className="drill-col__header-title">{header}</span>
            {showAdd && (
                <button
                    type="button"
                    className="drill-col__add-btn"
                    title={`Add ${header}`}
                    onClick={(e) => { e.stopPropagation(); onAdd(); }}
                >
                    <PlusIcon />
                </button>
            )}
        </div>
        <div className="drill-col__body">
            {children}
        </div>
    </div>
);

const DrillEmpty = ({ message }) => (
    <div className="drill-empty">
        <span>{message}</span>
    </div>
);

function MasterManagement() {
    const [currentMaster, setCurrentMaster] = useState(
        localStorage.getItem("currentMaster") || "Department"
    );
    const customId = "custom-id-yes";
    const [currentPage, setCurrentPage] = useState(1);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false);
    const [filteredData, setFilteredData] = useState([]);
    const [searchFilter, setSearchFilter] = useState("");

    const [expandedBrandId, setExpandedBrandId] = useState(null);
    const [expandedBrandName, setExpandedBrandName] = useState("");
    const [brandTypeDetails, setBrandTypeDetails] = useState([]);
    const [generationDetails, setGenerationDetails] = useState([]);
    const [expandLoading, setExpandLoading] = useState(false);
    const [roles, setRoles] = useState([]);
    const [rolesLoading, setRolesLoading] = useState(false);

    const [isSidebarOpen, setIsSidebarOpen] = useState(false);
    // sidebarMode: 'brand' | 'brandType' | 'generation' | 'department' | 'designation'
    const [sidebarMode, setSidebarMode] = useState("");
    const [sidebarAction, setSidebarAction] = useState("");
    const [editItemId, setEditItemId] = useState(null);
    const [sidebarValues, setSidebarValues] = useState({ name: "", brandName: "" });
    const [nameErrorMsg, setNameErrorMsg] = useState("");
    const [emailErrorMsg, setEmailErrorMsg] = useState("");
    const [roleErrorMsg, setRoleErrorMsg] = useState("");

    const fetchData = async (master) => {
        setLoading(false);
        setExpandedBrandId(null);
        setBrandTypeDetails([]);
        setGenerationDetails([]);
        try {
            let list = [];
            if (master === "Department") list = await getAllDepartments();
            else if (master === "Designation") list = await getAllDesignations();
            else if (master === "Processor") list = await getProcessorTypes();
            else if (master === "User") list = await getAllLoginUsers();
            setData(list);
            setFilteredData(list);
        } catch (err) {
            console.log(err.message);
        } finally {
            setLoading(true);
        }
    };

    useEffect(() => {
        fetchData(currentMaster);
    }, []);

    useEffect(() => {
        if (isSidebarOpen) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "";
        }
        return () => {
            document.body.style.overflow = "";
        };
    }, [isSidebarOpen]);

    useEffect(() => {
        const fetchRoles = async () => {
            setRolesLoading(true);
            try {
                const list = await getRoles();
                setRoles(list);
            } catch {
                // silent
            } finally {
                setRolesLoading(false);
            }
        };
        fetchRoles();
    }, []);

    const handleBrandClick = async (item) => {

        if (expandedBrandId === item.brandId) {
            setExpandedBrandId(null);
            setExpandedBrandName("");
            setBrandTypeDetails([]);
            setGenerationDetails([]);
            return;
        }
        setExpandedBrandId(item.brandId);
        setExpandedBrandName(item.brandName);
        setExpandLoading(true);
        try {
            const res = await getValueForProcessor(item.brandName);
            setBrandTypeDetails(res.brandTypeDetails || []);
            setGenerationDetails(res.generationDetails || []);
        } catch {
            toast.error("Failed to load processor details", { toastId: customId });
        } finally {
            setExpandLoading(false);
        }
    };

    const handleMasterClick = (master) => {
        setData([]);
        setFilteredData([]);
        setSearchFilter("");
        setCurrentPage(1);
        setCurrentMaster(master);
        localStorage.setItem("currentMaster", master);
        fetchData(master);
    };

    const handleSearch = (value) => {
        const temp = data.filter((obj) => {
            for (const key in obj) {
                if (
                    typeof obj[key] === "string" &&
                    obj[key].toLowerCase().includes(value.toLowerCase())
                )
                    return true;
            }
            return false;
        });
        setFilteredData(temp);
        setCurrentPage(1);
    };


    const openSidebar = (mode, action, item = null) => {
        setSidebarMode(mode);
        setSidebarAction(action);
        // setSidebarError(false);
        setNameErrorMsg("");
        setEmailErrorMsg("");
        setRoleErrorMsg("");
        setIsSidebarOpen(true);

        if (action === "edit" && item) {
            if (mode === "brand") {
                setEditItemId(item.brandId);
                setSidebarValues({ name: item.brandName, brandName: "" });
            } else if (mode === "brandType") {
                setEditItemId(item.id ?? item.brandTypeId);
                setSidebarValues({ name: item.brandTypeName, brandName: expandedBrandName });
            } else if (mode === "generation") {
                setEditItemId(item.id ?? item.generationId);
                setSidebarValues({ name: item.generation, brandName: expandedBrandName });
            } else if (mode === "department") {
                setEditItemId(item.id);
                setSidebarValues({ name: item.departmentName, brandName: "" });
            } else if (mode === "designation") {
                setEditItemId(item.id);
                setSidebarValues({ name: item.designationName, brandName: "" });
            } else if (mode === "user") {
                setEditItemId(item.id);
                getLoginUserById(item.id)
                    .then((u) => {
                        setSidebarValues({
                            name: u?.username ?? item.username,
                            emailid: u?.emailid ?? item.emailid,
                            roleid: u?.roleid ?? item.roleid ?? "",
                            brandName: "",
                        });
                    })
                    .catch(() => {
                        setSidebarValues({
                            name: item.username,
                            emailid: item.emailid,
                            roleid: item.roleid ?? "",
                            brandName: "",
                        });
                    });
            }
        }
        else {
            setEditItemId(null);
            setSidebarValues({ name: "", emailid: "", roleid: "", brandName: expandedBrandName });
        }
    };

    const closeSidebar = () => {
        setIsSidebarOpen(false);
        setSidebarMode("");
        setSidebarAction("");
        setEditItemId(null);
        setSidebarValues({ name: "", emailid: "", roleid: "", brandName: "" });
        // setSidebarError(false);
        setNameErrorMsg("");
        setEmailErrorMsg("");
        setRoleErrorMsg("");
    };

    const getSidebarTitle = () => {
        const verb = sidebarAction === "add" ? "Add" : "Update";
        if (sidebarMode === "brand") return `${verb} Processor Brand`;
        if (sidebarMode === "brandType") return `${verb} Processor Type`;
        if (sidebarMode === "generation") return `${verb} Generation`;
        if (sidebarMode === "department") return `${verb} Department`;
        if (sidebarMode === "designation") return `${verb} Designation`;
        if (sidebarMode === "user") return `${verb} User`;
        return verb;
    };

    const getFieldLabel = () => {
        if (sidebarMode === "brand") return "Processor Brand Name";
        if (sidebarMode === "brandType") return "Processor Type Name";
        if (sidebarMode === "generation") return "Generation";
        if (sidebarMode === "department") return "Department Name";
        if (sidebarMode === "designation") return "Designation Name";
        if (sidebarMode === "user") return "User Name";
        return "Name";
    };

    const getFieldPlaceholder = () => {
        if (sidebarMode === "brand") return "Enter Processor Brand Name";
        if (sidebarMode === "brandType") return "Enter Processor Type Name";
        if (sidebarMode === "generation") return "Enter Generation";
        if (sidebarMode === "department") return "Enter Department Name";
        if (sidebarMode === "designation") return "Enter Designation Name";
        if (sidebarMode === "user") return "Enter User Name";
        return "Name";
    };

    const getFieldMessageLabel = () => {
        if (sidebarMode === "brand") return "Processor brand name";
        if (sidebarMode === "brandType") return "Processor type name";
        if (sidebarMode === "generation") return "Generation";
        if (sidebarMode === "department") return "Department name";
        if (sidebarMode === "designation") return "Designation name";
        if (sidebarMode === "user") return "User name";
        return "Name";
    };

    const handleSidebarSubmit = async () => {
        const trimmed = sidebarValues.name.trim();
        const emailTrimmed = sidebarValues.emailid?.trim() || "";
        const roleidVal = sidebarValues.roleid;

        const nameMsg = validateNameField(sidebarValues.name, getFieldMessageLabel());
        const emailMsg = sidebarMode === "user" ? validateEmailField(emailTrimmed) : "";
        const roleMsg = sidebarMode === "user" && !roleidVal ? "Please select a role" : "";

        setNameErrorMsg(nameMsg);
        setEmailErrorMsg(emailMsg);
        setRoleErrorMsg(roleMsg);

        if (nameMsg || emailMsg || roleMsg) {
            toast.error(nameMsg || emailMsg || roleMsg, { toastId: customId });
            return;
        }


        try {
            let res;

            if (sidebarAction === "add") {
                if (sidebarMode === "brand") {
                    res = await addProcessor(trimmed);
                } else if (sidebarMode === "brandType") {
                    res = await addBrandType(expandedBrandId, trimmed);
                } else if (sidebarMode === "generation") {
                    res = await addGeneration(expandedBrandId, trimmed);
                } else if (sidebarMode === "department") {
                    res = await addDepartment(trimmed);
                } else if (sidebarMode === "designation") {
                    res = await addDesignation(trimmed);
                } else if (sidebarMode === "user") {
                    res = await addUser({
                        username: trimmed,
                        emailid: emailTrimmed,
                        roleid: Number(roleidVal),
                    });
                }
            } else {
                if (sidebarMode === "brand") {
                    res = await updateProcessor(editItemId, trimmed);
                } else if (sidebarMode === "brandType") {
                    res = await updateBrandType(editItemId, trimmed);
                } else if (sidebarMode === "generation") {
                    res = await updateGeneration(editItemId, trimmed);
                } else if (sidebarMode === "department") {
                    res = await updateDepartment(editItemId, trimmed);
                } else if (sidebarMode === "designation") {
                    res = await updateDesignation(editItemId, trimmed);
                } else if (sidebarMode === "user") {
                    res = await updateUser({
                        id: editItemId,
                        username: trimmed,
                        emailid: emailTrimmed,
                        roleid: Number(roleidVal),
                    });
                }
            }

            if (res?.statuscode === 200 || res?.response === true) {
                toast.success(res?.message || `${sidebarAction === "add" ? "Added" : "Updated"} successfully`, {
                    toastId: customId,
                });
                closeSidebar();
                if (sidebarMode === "brand") {
                    fetchData("Processor");
                } else if (sidebarMode === "brandType" || sidebarMode === "generation") {
                    const res2 = await getValueForProcessor(expandedBrandName);
                    setBrandTypeDetails(res2.brandTypeDetails || []);
                    setGenerationDetails(res2.generationDetails || []);
                } else {
                    fetchData(currentMaster);
                }
            } else {
                toast.error(res?.message || "Something went wrong", { toastId: customId });
            }
        } catch {
            toast.error("Something went wrong", { toastId: customId });
        }
    };

    const handleDelete = (item) => {
        confirmAlert({
            title: `Delete ${currentMaster}`,
            message: `Are you sure you want to delete this ${currentMaster}?`,
            buttons: [
                {
                    label: "Yes",
                    onClick: async () => {
                        try {
                            let url = "";
                            if (currentMaster === "Department")
                                url = AppSettings.URLs.asset + `Master/DeleteDepartment?id=${item.id}`;
                            else if (currentMaster === "Designation")
                                url = AppSettings.URLs.asset + `Master/DeleteDesignation?id=${item.id}`;
                            else return;
                            await axiosInstance.delete(url);
                            toast.success("Deleted successfully", { toastId: customId });
                            fetchData(currentMaster);
                        } catch {
                            toast.error("Something went wrong", { toastId: customId });
                        }
                    },
                },
                { label: "No" },
            ],
        });
    };

    const itemsPerPage = 10;
    const totalPages = Math.ceil((filteredData?.length || 0) / itemsPerPage);
    const startIndex = (currentPage - 1) * itemsPerPage;
    const endIndex = currentPage * itemsPerPage;
    const displayedData = filteredData.slice(startIndex, endIndex);

    const goToPreviousPage = () => { if (currentPage > 1) setCurrentPage((p) => p - 1); };
    const goToNextPage = () => { if (endIndex < filteredData.length) setCurrentPage((p) => p + 1); };

    const renderPageNumbers = () => {
        const maxToShow = 3;
        const pageNumbers = [];
        let startPage, endPage;
        if (totalPages <= maxToShow) { startPage = 1; endPage = totalPages; }
        else {
            const mid = Math.ceil(maxToShow / 2);
            if (currentPage <= mid) { startPage = 1; endPage = maxToShow; }
            else if (currentPage + mid - 1 >= totalPages) { startPage = totalPages - maxToShow + 1; endPage = totalPages; }
            else { startPage = currentPage - mid + 1; endPage = currentPage + mid - 1; }
        }
        if (startPage > 1) { pageNumbers.push(1); if (startPage > 2) pageNumbers.push("..."); }
        for (let i = startPage; i <= endPage; i++) pageNumbers.push(i);
        if (endPage < totalPages) { if (endPage < totalPages - 1) pageNumbers.push("..."); pageNumbers.push(totalPages); }

        return pageNumbers.map((n, i) =>
            typeof n === "number" ? (
                <li key={i} className={`inline-block cursor-pointer hover:backdrop-brightness-90 ${currentPage === n ? "current" : ""}`} onClick={() => setCurrentPage(n)}>
                    <span>{n}</span>
                </li>
            ) : (
                <li key={i} className="inline-block mx-1">{n}</li>
            )
        );
    };

    const getNonProcessorMode = () => {
        if (currentMaster === "Department") return "department";
        if (currentMaster === "Designation") return "designation";
        if (currentMaster === "User") return "user";
        return "";
    };

    const getColumnLabel = () => {
        if (currentMaster === "Department") return "Department Name";
        if (currentMaster === "Designation") return "Designation Name";
        if (currentMaster === "User") return "User Name";
        return "";
    };

    const getColumnKey = () => {
        if (currentMaster === "Department") return "departmentName";
        if (currentMaster === "Designation") return "designationName";
        if (currentMaster === "User") return "username";
        return "";
    };

    return (
        <>
            {/* Page header */}
            <div className="page-titles bg-white px-6">
                <div className="flex items-center">
                    <div className="mr-4 kr-page-back-btn">
                        <NavLink to="/master" className="no-underline">
                            <button type="button" className="btn-primary rounded flex items-center justify-center w-8">
                                <svg width={18} className="svg-white" x="0px" y="0px" viewBox="0 0 700 700">
                                    <g>
                                        <path d="M82.9,331.2l148.3,148.3c7.6,7.6,18.6,10.6,29,7.8c10.4-2.8,18.5-10.9,21.2-21.2c2.8-10.4-0.2-21.4-7.8-29l-97.6-96.9h304.7c15.8,0,31,6.3,42.1,17.5c11.2,11.2,17.5,26.3,17.5,42.1v79c0,10.6,5.7,20.5,14.9,25.8c9.2,5.3,20.6,5.3,29.8,0c9.2-5.3,14.9-15.2,14.9-25.8v-79c0-31.6-12.6-61.9-34.9-84.3c-22.4-22.4-52.7-34.9-84.3-34.9H176.1l97.6-97.6c7.6-7.6,10.6-18.6,7.8-29c-2.8-10.4-10.9-18.5-21.2-21.2c-10.4-2.8-21.4,0.2-29,7.8L82.9,288.7c-5.7,5.6-8.9,13.3-8.9,21.2S77.2,325.6,82.9,331.2z" />
                                    </g>
                                </svg>
                            </button>
                        </NavLink>
                    </div>
                    <div>
                        <h2 className="font-bold color-dark text-[14px] mb-0">Masters</h2>
                        <span className="text-gray-400 text-[12px]">View all masters listing</span>
                    </div>
                </div>
            </div>

            <div className="pageBody-inner px-0 pt-0">
                <div className="kr-block">
                    <div className="tabs">

                        <div className="tab-button-outer">
                            <div id="tab-button">
                                {["Department", "Designation", "Processor", "User"].map((tab) => (
                                    <li key={tab} className={currentMaster === tab ? "is-active" : ""}>
                                        <div className="kr-asset-tab" onClick={() => handleMasterClick(tab)}>
                                            <div className={`kr-emp-tab ${currentMaster === tab ? "kr-emp-tab-active border-danger border-top-0 border-end-0 border-start-0 border-2 text-dark" : ""}`}>
                                                {tab}
                                            </div>
                                        </div>
                                    </li>
                                ))}
                            </div>
                        </div>

                        <div className="pageBody-inner p-6">
                            <div className="kr-block">
                                <div className="card !border-none">
                                    <div className="card-inner p-0">

                                        {currentMaster !== "Processor" && (
                                            <div className="kr-table-header border-bottom px-6 py-3">
                                                <div className="w-100 flex items-center justify-between">
                                                    <div className="flex place-content-center user-search-filter-parent h-[32px]">
                                                        <input
                                                            type="text"
                                                            value={searchFilter}
                                                            placeholder="Search..."
                                                            className="user-search-filter-input"
                                                            onChange={(e) => {
                                                                setSearchFilter(e.target.value);
                                                                handleSearch(e.target.value);
                                                            }}
                                                        />
                                                    </div>
                                                    <button
                                                        type="button"
                                                        className="btn btn-primary flex justify-center items-center min-w-80 cursor-pointer"
                                                        onClick={() => openSidebar(getNonProcessorMode(), "add")}
                                                    >
                                                        Create
                                                    </button>
                                                </div>
                                            </div>
                                        )}

                                        <div className="kr-block px-3 pt-2 pb-3">
                                            <div className="overflow-x-auto">
                                                {loading ? (
                                                    <>
                                                        {currentMaster === "Processor" && (
                                                            <div className="drill-wrap">

                                                                <DrillColumn
                                                                    header="Processor Brand"
                                                                    showAdd={true}
                                                                    onAdd={() => openSidebar("brand", "add")}
                                                                >
                                                                    {displayedData.length === 0 ? (
                                                                        <DrillEmpty message="No brands found" />
                                                                    ) : (
                                                                        displayedData.map((brand) => (
                                                                            <DrillRow
                                                                                key={brand.brandId}
                                                                                label={brand.brandName}
                                                                                active={expandedBrandId === brand.brandId}
                                                                                onClick={() => handleBrandClick(brand)}
                                                                                onEdit={(e) => {
                                                                                    e.stopPropagation();
                                                                                    openSidebar("brand", "edit", brand);
                                                                                }}
                                                                            />
                                                                        ))
                                                                    )}
                                                                </DrillColumn>

                                                                <DrillColumn
                                                                    header="Processor Type"
                                                                    showAdd={!!expandedBrandId}
                                                                    onAdd={() => openSidebar("brandType", "add")}
                                                                >
                                                                    {!expandedBrandId ? (
                                                                        <DrillEmpty message="Select a brand" />
                                                                    ) : expandLoading ? (
                                                                        <div className="drill-loading">
                                                                            <div className="kr-pageLoader"><span className="loader"></span></div>
                                                                        </div>
                                                                    ) : brandTypeDetails.length === 0 ? (
                                                                        <DrillEmpty message="No types added yet" />
                                                                    ) : (
                                                                        brandTypeDetails.map((t, i) => (
                                                                            <DrillRow
                                                                                key={t.brandTypeId ?? i}
                                                                                label={t.brandTypeName}
                                                                                onClick={() => { }}
                                                                                onEdit={(e) => {
                                                                                    e.stopPropagation();
                                                                                    openSidebar("brandType", "edit", t);
                                                                                }}
                                                                            />
                                                                        ))
                                                                    )}
                                                                </DrillColumn>


                                                                <DrillColumn
                                                                    header="Process Generation"
                                                                    showAdd={!!expandedBrandId}
                                                                    onAdd={() => openSidebar("generation", "add")}
                                                                >
                                                                    {!expandedBrandId ? (
                                                                        <DrillEmpty message="Select a brand" />
                                                                    ) : expandLoading ? (
                                                                        <div className="drill-loading">
                                                                            <div className="kr-pageLoader"><span className="loader"></span></div>
                                                                        </div>
                                                                    ) : generationDetails.length === 0 ? (
                                                                        <DrillEmpty message="No generations added yet" />
                                                                    ) : (
                                                                        generationDetails.map((g, i) => (
                                                                            <DrillRow
                                                                                key={g.generationId ?? i}
                                                                                label={g.generation}
                                                                                onClick={() => { }}
                                                                                onEdit={(e) => {
                                                                                    e.stopPropagation();
                                                                                    openSidebar("generation", "edit", g);
                                                                                }}
                                                                            />
                                                                        ))
                                                                    )}
                                                                </DrillColumn>

                                                            </div>
                                                        )}

                                                        {currentMaster !== "Processor" && (
                                                            displayedData.length > 0 ? (
                                                                <table className="table kr-table-striped">
                                                                    <thead>
                                                                        <tr>
                                                                            <th className="text-center">#</th>
                                                                            <th>{getColumnLabel()}</th>
                                                                            {currentMaster === "User" && <th>Email ID</th>}
                                                                            {currentMaster === "User" && <th>Role</th>}
                                                                            <th className="text-center">Action</th>
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        {displayedData.map((item, index) => (
                                                                            <tr key={index}>
                                                                                <td className="text-center">{startIndex + index + 1}</td>
                                                                                <td>{item[getColumnKey()]}</td>
                                                                                {currentMaster === "User" && <td>{item.emailid}</td>}
                                                                                {currentMaster === "User" && <td>{item.rolename}</td>}
                                                                                <td className="kr-tbl-action">
                                                                                    <div className="flex justify-center shrink-0">
                                                                                        <ul className="flex">
                                                                                            <li>
                                                                                                <div
                                                                                                    className="kr-tbl-edit cursor-pointer action-item"
                                                                                                    onClick={() => openSidebar(getNonProcessorMode(), "edit", item)}
                                                                                                >
                                                                                                    <span className="svg-icon"><EditIcon /></span>
                                                                                                </div>
                                                                                            </li>
                                                                                        </ul>
                                                                                    </div>
                                                                                </td>
                                                                            </tr>
                                                                        ))}
                                                                    </tbody>
                                                                </table>
                                                            ) : (
                                                                <div className="flex flex-col items-center justify-center gap-2 py-10">
                                                                    <img
                                                                        src={NoDataFoundImage}
                                                                        alt="No Data Found"
                                                                        className="w-[120px] h-[120px] opacity-80"
                                                                    />
                                                                    <span className="text-gray-500 text-[13px] font-semibold">
                                                                        No Data Found
                                                                    </span>
                                                                </div>
                                                            )
                                                        )}
                                                    </>
                                                ) : (
                                                    <div className="w-100 flex justify-center items-center py-6 bg-light">
                                                        <div className="kr-pageLoader"><span className="loader"></span></div>
                                                    </div>
                                                )}
                                            </div>
                                        </div>

                                        {/* Pagination */}
                                        {displayedData.length > 0 && (
                                            <div className="kr-block pt-3 pb-3 font-size-12px color-gray border-top px-3">
                                                <nav className="w-full m-0">
                                                    <ul className="list-none ml-0 mb-0 pagination">
                                                        <li className={`inline-block pagination-prev cursor-pointer ${currentPage === 1 ? "disabled" : ""}`} onClick={goToPreviousPage}>
                                                            <span>Previous</span>
                                                        </li>
                                                        {renderPageNumbers()}
                                                        <li className={`inline-block pagination-next cursor-pointer ${endIndex >= filteredData?.length ? "disabled" : ""}`} onClick={goToNextPage}>
                                                            <span>Next</span>
                                                        </li>
                                                    </ul>
                                                </nav>
                                            </div>
                                        )}

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/*Sidebar */}
            <div className={`kr-popup-overlay ${isSidebarOpen ? "kr-side-popup-overlay" : ""}`}></div>
            <div className={`kr-side-popup ${isSidebarOpen ? "kr-side-popup-on md:!w-[500px] !w-[90vw]" : ""}`}>
                <div className="kr-block w-100">
                    <div className="flex items-center py-[16px] px-6 bg-gray-50">
                        <div className="pl-2">
                            <h2 className="font-bold color-dark text-[14px] mb-0">{getSidebarTitle()}</h2>
                            <span className="text-gray-400 text-[12px]">
                                {sidebarAction === "add" ? "Create" : "Update"} below
                            </span>
                        </div>
                    </div>
                    <div className="kr-block p-4">
                        <div className="grid gap-x-4 grid-cols-1">

                            {(sidebarMode === "brandType" || sidebarMode === "generation") && (
                                <div className="col-span-1 mb-3">
                                    <div className="kr-selectform">
                                        <label className="kr-form-label">Processor Brand</label>
                                        <input
                                            type="text"
                                            value={expandedBrandName}
                                            readOnly
                                            className="form-control kr-form-textbox bg-gray-100 text-gray-500"
                                        />
                                    </div>
                                </div>
                            )}

                            <div className="col-span-1">
                                <div className="kr-selectform required">
                                    <label className="kr-form-label">{getFieldLabel()}</label>
                                    <input
                                        type="text"
                                        placeholder={getFieldPlaceholder()}
                                        value={sidebarValues.name}
                                        maxLength={50}
                                        className={`form-control kr-form-textbox placeholder-[#212529] ${nameErrorMsg ? "dataError" : ""}`}
                                        onChange={(e) => {
                                            let val = e.target.value;

                                            if (val.length > 0) {
                                                val = val.charAt(0).toUpperCase() + val.slice(1);
                                            }

                                            val = val.replace(/ {2,}/g, " ");

                                            setSidebarValues((v) => ({ ...v, name: val }));
                                            if (nameErrorMsg) {
                                                const msg = validateNameField(val, getFieldMessageLabel());
                                                setNameErrorMsg(msg);
                                            }
                                        }}
                                        onBlur={(e) => setNameErrorMsg(validateNameField(e.target.value, getFieldMessageLabel()))}
                                    />
                                    {nameErrorMsg && (
                                        <span className="text-red-500 text-[11px] mt-1 block">{nameErrorMsg}</span>
                                    )}
                                </div>
                            </div>

                            {sidebarMode === "user" && (
                                <>
                                    <div className="kr-selectform required">
                                        <label className="kr-form-label">Email ID</label>
                                        <input
                                            type="email"
                                            placeholder="Enter Email ID"
                                            value={sidebarValues.emailid || ""}
                                            className={`form-control kr-form-textbox placeholder-[#212529] ${emailErrorMsg ? "dataError" : ""}`}
                                            onChange={(e) => {
                                                setSidebarValues((v) => ({ ...v, emailid: e.target.value }));
                                                if (emailErrorMsg) {
                                                    setEmailErrorMsg(validateEmailField(e.target.value));
                                                }
                                            }}
                                            onBlur={(e) => setEmailErrorMsg(validateEmailField(e.target.value))}
                                        />
                                        {emailErrorMsg && (
                                            <span className="text-red-500 text-[11px] mt-1 block">{emailErrorMsg}</span>
                                        )}
                                    </div>

                                    <div className="kr-selectform required">
                                        <label className="kr-form-label">Role</label>
                                        <Select
                                            searchable={false}
                                            backspaceDelete={false}
                                            placeholder="Select Role"
                                            values={
                                                sidebarValues.roleid
                                                    ? [{ value: sidebarValues.roleid, label: roles.find(r => String(r.id) === String(sidebarValues.roleid))?.roleName || "" }]
                                                    : []
                                            }
                                            className={`form-control kr-form-textbox placeholder-[#212529] ${roleErrorMsg ? "dataError" : ""}`}
                                            options={roles.map((r) => ({
                                                value: r.id,
                                                label: r.roleName,
                                            }))}
                                            onChange={(selectedOption) => {
                                                setSidebarValues((v) => ({ ...v, roleid: selectedOption[0]?.value ?? "" }));
                                                setRoleErrorMsg("");
                                            }}
                                        />
                                        {roleErrorMsg && (
                                            <span className="text-red-500 text-[11px] mt-1 block">{roleErrorMsg}</span>
                                        )}
                                    </div>

                                </>
                            )}

                            <div className="col-span-1 mt-4">
                                <div className="kr-selectform flex justify-end">
                                    <button
                                        type="button"
                                        className="flex items-center justify-center py-[6px] px-[12px] btn-light border border-solid border-gray-200 rounded min-w-80"
                                        onClick={closeSidebar}
                                    >
                                        Cancel
                                    </button>
                                    <button
                                        type="button"
                                        className="btn btn-primary flex items-center justify-center ml-2 min-w-80"
                                        onClick={handleSidebarSubmit}
                                    >
                                        {sidebarAction === "add" ? "Add" : "Update"}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default MasterManagement;